import Http from '@/services/http';
import { RegulationSetResponse } from 'sigma-mappings';

const urls = {
  getRegulationSets: moduleAssetId => `/supervisao/${moduleAssetId}/conjuntos-regulacao`,
};

export default {
  getRegulationSets(moduleAssetId) {
    return new Http()
      .get(urls.getRegulationSets(moduleAssetId))
      .then(({ data }) => {
        const mappedResponse = data.map(item => new RegulationSetResponse(item));
        return mappedResponse.map((item, index) => ({ ...item, number: index + 1 }));
      });
  },
};
